<template>
  <button
    class="text-xl font-medium text-brand text-nowrap"
    @click="handlePaymentStart"
  >
    + {{ $t('b2b|header|button|create_payment_link') }}
  </button>

  <modal-payment-link
    v-model="showCreatePayment"
    :is-update="isUpdatePaymentLink"
    :item="element"
    @onSubmit="submitCreatePayment"
    @reset-update="resetUpdate"
  />

  <modal-payment-link-success-create
    v-model="showSuccessPayment"
    :item="element"
    @onUpdate="openUpdatePaymentLink"
  />
</template>

<script setup>
import { usePaymentLink } from '@/shared/composables/usePaymentLink'
import ModalPaymentLink from '@/widgets/ModalPaymentLink/ui/ModalPaymentLink.vue'
import ModalPaymentLinkSuccessCreate from '@/widgets/ModalPaymentLinkSuccessCreate/ui/ModalPaymentLinkSuccessCreate.vue'

const {
  showCreatePayment,
  showSuccessPayment,
  element,
  isUpdatePaymentLink,
  handlePaymentStart,
  submitCreatePayment,
  openUpdatePaymentLink,
  resetUpdate,
} = usePaymentLink()
</script>
